import React from 'react';
import PropTypes from 'prop-types';
import { TableHeaderColumn } from 'react-bootstrap-table';

const TableColumn = (props) => {
    return(
        <TableHeaderColumn
            width={props.width}
            tdStyle={{ whiteSpace: 'pre-line' }}
            dataField={props.dataField}>
            {props.label}
        </TableHeaderColumn>
    );
};

TableColumn.propTypes = {
    dataField: PropTypes.string,
    label: PropTypes.string,
    width: PropTypes.string
};

export default TableColumn;


// WEBPACK FOOTER //
// ./src/components/base/Table/BootstrapTableColumn.js